"use client";

import { createContext, useContext, type ReactNode } from "react";
import {
    DEFAULT_NAV_THEME,
    navThemeStyles,
    type NavTheme,
    type NavThemeStyles,
} from "./nav-theme";

const NavThemeContext = createContext<NavTheme>(DEFAULT_NAV_THEME);

type NavThemeProviderProps = {
    value: NavTheme;
    children: ReactNode;
};

/** Must be a function component — re-exporting Context.Provider breaks RSC/lazy. */
export function NavThemeProvider({ value, children }: NavThemeProviderProps) {
    return (
        <NavThemeContext.Provider value={value}>{children}</NavThemeContext.Provider>
    );
}

export function useNavTheme(): NavTheme {
    return useContext(NavThemeContext);
}

export function useNavThemeStyles(): NavThemeStyles {
    return navThemeStyles[useNavTheme()];
}

export type { NavTheme, NavThemeStyles };
export { DEFAULT_NAV_THEME, navThemeStyles };
